import React, { useState, useEffect } from 'react';
import { IonContent, IonHeader, IonPage, IonItem, IonLabel, IonIcon, IonToggle, IonItemDivider, IonLoading} from '@ionic/react';
import { RouteComponentProps } from 'react-router-dom';
import HeaderSimple from '../components/HeaderSimple';
import { Plugins } from '@capacitor/core';
import { loadLists } from '../services/utils';
import { appVersion } from '../services/asyncDataService';

import { logOutOutline, reloadOutline } from 'ionicons/icons';
import './css/common.css';

interface ResultsProps extends RouteComponentProps {
    type:string
}

const { Network } = Plugins;

const Results: React.FC<ResultsProps> = ({history, location, match}) => {
    const [format24, setFormat24] = useState(false);
    const [isOnline, setIsOnline] = useState<boolean>(window.localStorage.getItem("online") !== "0");
    const [showLoading, setShowLoading] = useState(false);

    useEffect(() => {
        Network.addListener("networkStatusChange", status => {
          setIsOnline(status.connected);
          if (status.connected)
            window.localStorage.setItem("online", "1");
          else
            window.localStorage.setItem("online", "0");
        });
    
        return () => Network.removeAllListeners();
      },[])

    useEffect(() => {
        if (window.localStorage.getItem("format24")) {
            let _value24 = String(window.localStorage.getItem("format24"));
            if (_value24 === "1")
                setFormat24(true);
            else
                setFormat24(false);
        }
    }, [isOnline]);

    const logout = () => {
        localStorage.clear();
        history.push("/login");
    }

    const reloadCache = () => {
        let _token = String(window.localStorage.getItem("token"));
        let _username = String(window.localStorage.getItem("username"));
        setShowLoading(true);
        loadLists(_token, _username);
        setTimeout(
            () => {setShowLoading(false)}, 
        10000);
        
    }

    const changeFormat = (_e:any) => {
        setFormat24(_e.detail.checked);
        if (_e.detail.checked)
            window.localStorage.setItem("format24", "1");
        else
            window.localStorage.setItem("format24", "0");
    }

    return (
        <IonPage>
            <IonHeader mode="ios">
                <HeaderSimple headerTitle="User Details" history={history} 
                        location={location} match={match}></HeaderSimple>
            </IonHeader>
            <IonContent>
                <IonItemDivider mode="ios" className="my-divider">Settings</IonItemDivider>
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label">24 hours format</IonLabel>
                    <IonToggle mode="ios" checked={format24} color="success" onIonChange={e => changeFormat(e)} />
                </IonItem>
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label">Refresh Cache</IonLabel>
                    <IonIcon  mode="ios" className="my-logout-icon" icon={reloadOutline} slot="end" onClick={reloadCache} />
                </IonItem>
                <IonItem mode="ios" className="my-ion-item">
                    <IonLabel mode="ios" className="my-ion-item-label">Version</IonLabel>
                    <IonLabel mode="ios" className="my-logout-version">{appVersion}</IonLabel>
                </IonItem>
                <IonItem mode="ios" className="my-ion-item" >
                    <IonLabel mode="ios" className="my-ion-item-label">Logout</IonLabel>
                    <IonIcon  mode="ios" className="my-logout-icon" icon={logOutOutline} slot="end" onClick={logout} />
                </IonItem>
            </IonContent>
            <IonLoading mode="ios"
                cssClass='my-loading'
                isOpen={showLoading}
                onDidDismiss={() => setShowLoading(false)}
                message={"Refreshing cache..."}
            />
        </IonPage>
    );
};
export default Results;